import Lenis from 'lenis'
import 'lenis/dist/lenis.css'
import { gsap } from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'
import { reduceMotion } from '@js/animations/ReducedMotion'

let lenisInstance = null

export const getLenis = () => lenisInstance

export class Scroll {
  constructor () {
    if (reduceMotion) {
      return
    }

    lenisInstance = new Lenis({
      lerp: 0.1,
      duration: 0.7,
      wheelMultiplier: 0.7,
    })

    lenisInstance.on('scroll', ScrollTrigger.update)

    gsap.ticker.add((time) => {
      lenisInstance.raf(time * 1000)
    })

    gsap.ticker.lagSmoothing(0)
  }
}
